import createRoute        from '@widesk-ui/tools/createRoute';
import StandTypologyModel from '@models/website/StandTypologyModel';

const route = createRoute.splitView(
	'/configuration/stand_typologies',
	'website',
	'StandTypologySplitView',
	StandTypologyModel.localize('plural'),
);
export default route;
